type Primative = string | number | boolean | null | undefined;
export type PlainObject = {
  [key: string]: Primative | Array<Primative | PlainObject> | PlainObject;
};
type AnyObj = Primative | Array<Primative | PlainObject> | PlainObject;

type Options = {
  stripKeys?: string[];
};

/**
 * Regex to identify private keys
 * such as `_id`, `_slug`
 */
const rPrivate = /^_/;
/**
 * Deep recursive function to strip our private
 * fields from the Schema.org data.
 *
 * TODO: Add options for `createId/createUrl`
 * in order to "fill-in" the graph correctly
 * so Google can crawl the data and connect
 * up each of our pages.
 */
export function toJsonLd<T extends AnyObj = AnyObj>(
  obj: T,
  { stripKeys = ["email"] }: Options = {}
): T {
  if (
    typeof obj === "string" ||
    typeof obj === "number" ||
    typeof obj === "boolean" ||
    obj == null
  ) {
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map((v) => toJsonLd(v)) as T;
  }
  const keys = Object.keys(obj);
  if (keys.length) {
    const nextObj = {} as PlainObject;
    for (const key of keys) {
      if (!rPrivate.test(key) && !stripKeys.includes(key)) {
        nextObj[key] = toJsonLd(obj[key]);
      }
    }
    return nextObj as T;
  }
  return obj;
}
